export default __webpack_public_path__ + "static/media/wallet-product-learn-and-earn.49cd23b6.svg";